const getMarginsY = element => {
  try {
    var _window, _window2;
    const marginsHeight = parseInt((_window = window) == null ? void 0 : _window.getComputedStyle(element).marginTop, 10) + parseInt((_window2 = window) == null ? void 0 : _window2.getComputedStyle(element).marginBottom, 10);
    return marginsHeight;
  } catch (error) {
    return 0;
  }
};
const measuringFlag = function (reference, layoutType) {
  if (layoutType === void 0) {
    layoutType = 'grid-card';
  }
  return Boolean(reference && reference.querySelectorAll(`.poly-card--${layoutType}`));
};
const measuringHeight = function (reference, layoutType) {
  if (layoutType === void 0) {
    layoutType = 'grid-card';
  }
  try {
    var _footerTagArray$map$s;
    const cardClassNameHeader = 'poly-card__portada';
    const cardClassNameBody = `poly-card--${layoutType} .poly-card__content`;
    const cardClassNameFooter = `poly-card--${layoutType} .poly-card__footer`;
    const headerTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameHeader}`));
    const bodyTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameBody}:not(.${cardClassNameHeader})`));
    const footerTagArray = Array.from(reference.querySelectorAll(`.${cardClassNameFooter}`));
    const maxHeaderHeight = headerTagArray.map(item => item.getBoundingClientRect().height).sort((a, b) => b - a)[0] + getMarginsY(headerTagArray[0]);
    const maxBodyHeight = bodyTagArray.map(item => item.getBoundingClientRect().height).sort((a, b) => b - a)[0];
    const maxBodyFooter = (_footerTagArray$map$s = footerTagArray.map(item => item.getBoundingClientRect().height).sort((a, b) => b - a)[0]) != null ? _footerTagArray$map$s : 0;
    const height = layoutType.includes('list') ? Math.max(maxBodyHeight, maxHeaderHeight) : maxBodyHeight + maxHeaderHeight + maxBodyFooter;
    return Number.isNaN(height) ? 0 : height;
  } catch (error) {
    return 0;
  }
};
export { measuringFlag as a, measuringHeight as m };
